import { Box, Button, CircularProgress } from "@mui/material";
import { InputFileDropBox } from "components/inputs/InputFileDropBox";
import { ModalV1 } from "components/modals/ModalV1";
import { useState } from "react";
import { querySendApplicationCoverLetter } from "service/api";
import { EAssignerType } from "types";

export const ModalSendCoverLetter = ({
  open,
  handleClose,
  assignerType,
  applicationId,
}: {
  open: boolean;
  handleClose: () => any;
  assignerType: EAssignerType;
  applicationId: string;
}) => {
  const [file, setFile] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const handleClickSend = async () => {
    try {
      setLoading(true);

      if (!file) return;
      const formData = new FormData();
      formData.set("file", file);
      const res = await querySendApplicationCoverLetter({
        applicationId,
        assignerType,
        formData,
      });

      if (res?.data.link) window.location.href = res?.data.link;
      handleClose();
    } catch (error: any) {
      console.log(error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalV1
      open={open}
      handleClose={handleClose}
      title={"Отправка сопроводительного письма"}
      children={
        <>
          <InputFileDropBox
            setFile={setFile}
            file={file}
            description="Отправка сопроводительного письма"
          />
          <Box
            sx={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              onClick={handleClickSend}
              disabled={!file || loading}
              sx={{
                gap: "8px",
              }}
            >
              {loading ? <CircularProgress size={20} /> : null}
              {loading ? `Отправка...` : `Отправить`}
            </Button>
          </Box>
        </>
      }
    />
  );
};
